<template>
  <div class="container">
    <div class="title">药品求购</div>
    <div class="form1">
      <div class="left">
        <div class="item">
          <div class="img"></div>
          <div class="text">告诉我们你需要什么</div>
        </div>
        <div class="item">
          <div class="img img2"></div>
          <div class="text">接收我们反馈的详细信息</div>
        </div>
        <div class="item">
          <div class="img img3"></div>
          <div class="text">达成协议</div>
        </div>
      </div>
      <div class="right">
        <div class="tip">省时间，可免费获取相关药品的信息，快来试试！</div>
        <BuyDrugForm></BuyDrugForm>
      </div>
    </div>
  </div>
</template>

<script>
import BuyDrugForm from "@/components/pc/BuyDrugForm";
export default {
  name: "BuyDrug",
  components: { BuyDrugForm },
  data() {
    return {
      formValidate: {
        drugname: "",
        num: "",
        manufacturer: "",
        name: "",
        email: "",
        phone: "",
        message: ""
      },
      ruleValidate: {
        drugname: [
          { required: true, message: "药品名称不能为空", trigger: "blur" }
        ],
        num: [{ required: true, message: "数量不能为空", trigger: "blur" }],
        manufacturer: [{ required: false, message: "", trigger: "blur" }],
        name: [
          { required: true, message: "您的名称不能为空", trigger: "blur" }
        ],
        email: [
          { required: true, message: "邮箱不能为空", trigger: "blur" },
          { type: "email", message: "邮箱格式不正确", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "联系方式不能为空", trigger: "blur" }
        ],
        message: [{ required: false, message: "", trigger: "blur" }]
      }
    };
  }
};
</script>

<style lang="stylus" scoped>
.container
  width 800px
  margin 10px auto
  background #fff
  .title
    height 40px
    line-height 40px
    text-align center
    font-size 14px
  .form1
    margin-top 20px
    display flex
    height 500px
    .left
      width 200px
      background #1880f4
      display flex
      flex-direction column
      justify-content center
      align-items center
      .item
        height 120px
        .img
          width 30px
          height 30px
          margin 10px auto
          background-image url('../../assets/pc/images/index/blform.png')
          background-repeat no-repeat;
          background-position -223px -7px
          transform scale(1.2)
        .img2
          background-position -223px -54px
        .img3
          background-position -223px -100px
        .text
          color #fff
    .right
      flex 1
      border-top 1px solid #ccc
      border-bottom 1px solid #ccc
      .tip
        height 40px
        line-height 40px
        padding 0 20px
        color #666
        font-size 16px
        font-weight 700
        text-align center
</style>
